module.exports = __webpack_public_path__ + "cfd99453a2f9739a4718bf1cc6e1bf9c.png";